'use client'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'

// Dark-background closer, simplified. By this point the reader has
// scrolled every section and made up their mind — the closer's job is
// to give them ONE big obvious button + the urgency (deadline) to act
// now. Secondary CTA dropped (no need to re-offer the tour they've
// already implicitly seen). Copy tightened to a single headline +
// two-line supporting text.
export function LandingFinalCta() {
  return (
    <section className="px-6 py-24 sm:py-32 bg-gray-900 text-white relative overflow-hidden">
      {/* Subtle lavender bloom in the background */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background:
            'radial-gradient(circle at 30% 20%, rgba(108,95,199,0.35), transparent 55%), radial-gradient(circle at 70% 80%, rgba(108,95,199,0.25), transparent 60%)',
        }}
      />

      <div className="max-w-3xl mx-auto text-center relative">
        <h2 className="font-display font-bold text-5xl sm:text-6xl leading-[1] tracking-tight mb-8">
          See you{' '}
          <span className="italic text-bs-secondary-300">inside</span>.
        </h2>

        <div className="mb-10 space-y-1">
          <p className="text-[17px] sm:text-[19px] text-gray-200 leading-snug font-display font-semibold">
            Next cohort starts September 1.
          </p>
          <p className="text-[14px] text-gray-400 font-display font-medium">
            Applications close August 25.
          </p>
        </div>

        <Link
          href="/between-sessions/tour/join"
          className="group inline-flex items-center gap-3 pl-7 pr-3 py-4 text-[16px] font-display font-semibold rounded-full bg-white text-gray-900 hover:bg-gray-100 shadow-[0_16px_36px_-12px_rgba(0,0,0,0.5)] hover:-translate-y-0.5 transition-all duration-200"
        >
          Join Between Sessions
          <span className="w-9 h-9 rounded-full bg-gray-900/10 group-hover:bg-gray-900/20 flex items-center justify-center transition-colors">
            <ArrowRight className="w-4 h-4" />
          </span>
        </Link>

        <p className="mt-10 text-[12px] text-gray-500 font-display font-medium">
          Questions?{' '}
          <a
            href="mailto:hello@alli.io"
            className="text-gray-300 hover:text-white underline underline-offset-2"
          >
            hello@alli.io
          </a>
        </p>
      </div>
    </section>
  )
}
